import { render, staticRenderFns } from "./mineleft.vue?vue&type=template&id=bff12638&"
import script from "./mineleft.vue?vue&type=script&lang=js&"
export * from "./mineleft.vue?vue&type=script&lang=js&"
import style0 from "./mineleft.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports